import React, { useCallback, useRef, useState } from 'react';

import { FormControl, StyledOcticon } from '@primer/react';

import Button from '../Button/Button';
import CloudUploadIcon from '../icons/CloudUploadIcon';

export const FileInput = ({
  id = 'file-input',
  onFileOpened = () => {},
  error = null,
  disabled = false,
  defaultMessage = 'Select File',
}) => {
  const inputFile = useRef(null);
  const [fileMetaData, setFileMetaData] = useState(null);
  const displayLabel = fileMetaData ? fileMetaData.name : defaultMessage;

  const handleFileChange = useCallback((changeEvent) => {
    const files = changeEvent.target?.files;
    const file = files?.length ? files[0] : null;
    setFileMetaData(file);

    if (file) {
      const reader = new FileReader();

      // Closure to capture the file information.
      reader.onload = (() => (loadEvent) => {
        const content = loadEvent.target.result;
        if (content) {
          onFileOpened(content, file);
        } else {
          onFileOpened(null, file);
        }
      })(file);

      reader.readAsText(file);
    } else {
      onFileOpened(null, file);
    }
  }, [onFileOpened])

  const onClick = useCallback(() => {
    inputFile.current.click();
  }, [])

  return (
    <div>
      <FormControl>
        <FormControl.Label visuallyHidden>{displayLabel}</FormControl.Label>
        <input
          style={{ display: 'none' }}
          type="file"
          id={id}
          ref={inputFile}
          onChange={handleFileChange}
          multiple={false}
          disabled={disabled}
        />
        <Button onClick={onClick} disabled={disabled}>
          <div className="flex items-center justify-center">
            <StyledOcticon className="mr-2" icon={CloudUploadIcon} size={6} />
            {displayLabel}
          </div>
        </Button>
        {
          (error) ? (
            <FormControl.Validation variant="error">
              {error}
            </FormControl.Validation>
          ) : null
        }
      </FormControl>
    </div>
  )
}

export default FileInput;
